// ABOUTME: POST /companies/:id/members: staff add a member to a client company, with no password and no email sent.
// ABOUTME: A 409 (email taken) is shown in the form, so only other failures toast; the member list refetches.
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  AddCompanyMemberInput,
  AddCompanyMemberOutput,
  CompanyBuilder,
} from '../companies.types';

export const addCompanyMember = (builder: CompanyBuilder) =>
  builder.mutation<AddCompanyMemberOutput, AddCompanyMemberInput>({
    query: ({ companyId, FirstName, LastName, Email }) => ({
      url: `/companies/${companyId}/members`,
      method: 'POST',
      body: { FirstName, LastName, Email },
    }),
    transformResponse: (queryResponse: AddCompanyMemberOutput, _, arg) => {
      successHandler(
        arg.lang === 'es'
          ? SuccessMessageEs.MEMBER_ADDED
          : SuccessMessageEn.MEMBER_ADDED,
        true
      );
      return queryResponse;
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[addCompanyMember]',
        arg.lang === 'es'
          ? ErrorMessageEs.AddCompanyMember
          : ErrorMessageEn.AddCompanyMember,
        error,
        error.status !== 409
      );
      return error.data;
    },
    invalidatesTags: (_result, _error, { companyId }) => [
      { type: 'Company', id: `members-${companyId}` },
    ],
  });
